// Site configuration values sourced from environment variables.
// Set REACT_APP_FORM_ENDPOINT (e.g. https://formspree.io/f/XXXXXXXX) in the
// environment (.env locally, Render dashboard in production). Never hardcode
// the endpoint inside components.
export const FORM_ENDPOINT = process.env.REACT_APP_FORM_ENDPOINT;

export const CONTACT_EMAIL = "matthew@novasecurenet.com";
